import { FieldConfig } from 'model/deals.model';
import { useEffect, useState } from 'react';
import { DealsService } from 'service/deals.service';
import { BaseDealForm } from '../BaseDealForm';

const BASE_FIELDS: FieldConfig[] = [
  {
    name: 'dealDetails.stageName',
    label: 'Stage',
    type: 'select',
    required: true,
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.licenseType',
    label: 'License type',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.AIRightsFlag',
    label: 'AI rights flag',
    type: 'checkbox',
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.guaranteedMinimum',
    label: 'Guaranteed minimum ($)',
    type: 'number',
    xs: 12,
    sm: 6,
  },
  { name: 'dealDetails.royaltyRate', label: 'Royalty rate (%)', type: 'number', xs: 12, sm: 6 },
  { name: 'dealDetails.territory', label: 'Territory', type: 'select', options: [], xs: 12, sm: 6 },
  {
    name: 'dealDetails.productApproval',
    label: 'Product approval',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.reportingFrequency',
    label: 'Reporting frequency',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.revenueTier',
    label: 'Revenue tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.ceilingTier',
    label: 'Ceiling tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },

  {
    name: 'dealDetails.clientOrientation',
    label: 'Client orientation',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.careerState',
    label: 'Career stage',
    type: 'select',
    options: [],
    xs: 12,
    sm: 12,
  },
];

export const LicensingIP = () => {
  const [fields, setFields] = useState<FieldConfig[]>(BASE_FIELDS);

  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const dealTypeKey = 'LICENSING_IP';
        const dropdownsData = await DealsService.getDealDropdowns(dealTypeKey);

        const updatedFields = BASE_FIELDS.map((field) => {
          if (field.type === 'select' && field.options) {
            let options: string[] = [];

            switch (field.name) {
              case 'dealDetails.stageName':
                if (dropdownsData.stages && Array.isArray(dropdownsData.stages)) {
                  options = dropdownsData.stages.map((stage: any) => stage.stageName || stage);
                }
                break;
              case 'dealDetails.licenseType':
                if (dropdownsData.licenseType && Array.isArray(dropdownsData.licenseType)) {
                  options = [...dropdownsData.licenseType];
                }
                break;
              case 'dealDetails.reportingFrequency':
                if (
                  dropdownsData.reportingFrequency &&
                  Array.isArray(dropdownsData.reportingFrequency)
                ) {
                  options = [...dropdownsData.reportingFrequency];
                }
                break;
              case 'dealDetails.clientOrientation':
                if (
                  dropdownsData.clientOrientation &&
                  Array.isArray(dropdownsData.clientOrientation)
                ) {
                  options = [...dropdownsData.clientOrientation];
                }
                break;
              case 'dealDetails.revenueTier':
                if (dropdownsData.revenueTier && Array.isArray(dropdownsData.revenueTier)) {
                  options = [...dropdownsData.revenueTier];
                }
                break;
              case 'dealDetails.clientFitScore':
                if (dropdownsData.clientFitScore && Array.isArray(dropdownsData.clientFitScore)) {
                  options = [...dropdownsData.clientFitScore];
                }
                break;
              case 'dealDetails.careerStage':
                if (dropdownsData.careerStage && Array.isArray(dropdownsData.careerStage)) {
                  options = [...dropdownsData.careerStage];
                }
                break;
              case 'dealDetails.territory':
                if (dropdownsData.territory && Array.isArray(dropdownsData.territory)) {
                  options = [...dropdownsData.territory];
                }
                break;
              case 'dealDetails.productApproval':
                if (dropdownsData.productApproval && Array.isArray(dropdownsData.productApproval)) {
                  options = [...dropdownsData.productApproval];
                }
                break;
              default:
                options = field.options ? [...field.options] : [];
            }

            return {
              ...field,
              options: options.length > 0 ? options : field.options ? [...field.options] : [],
            };
          }
          return field;
        });

        setFields(updatedFields);
      } catch (error) {
        console.error('Failed to fetch dropdown values:', error);
        setFields(BASE_FIELDS);
      }
    };

    fetchDropdowns();
  }, []);

  return <BaseDealForm fields={fields} />;
};
